import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowUpRight, Compass } from "lucide-react";

/**
 * "Sector not listed?" callout — bespoke campaign CTA.
 * variant="full" (default): card for Sectors / Buy Leads pages.
 * variant="compact": slim inline strip for dense sections.
 */
export default function SectorCTA({ variant = "full" }) {
  if (variant === "compact") {
    return (
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-dashed border-slate-300 bg-white/70 px-5 py-4" data-testid="sector-cta-compact">
        <span className="grid place-items-center size-8 rounded-lg bg-slate-900 text-white shrink-0">
          <Compass className="size-4" strokeWidth={1.6} />
        </span>
        <p className="flex-1 text-sm text-slate-600">
          <span className="font-semibold text-slate-900">Your sector not listed?</span>{" "}
          We build bespoke campaigns beyond these ten — tell us your market and we'll scope it.
        </p>
        <Link to="/contact" className="shrink-0">
          <Button variant="outline" size="sm" className="rounded-full border-slate-300 hover:border-[#0055FF]/40 hover:text-[#0055FF]" data-testid="sector-cta-compact-btn">
            Discuss your sector <ArrowUpRight className="size-3.5" />
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10" data-testid="sector-cta">
      <div className="relative overflow-hidden rounded-2xl border border-dashed border-slate-300 bg-gradient-to-br from-white to-slate-50/60 px-7 sm:px-10 py-8 flex flex-col lg:flex-row lg:items-center gap-6">
        <div className="absolute -right-16 -top-16 size-48 rounded-full bg-[#0055FF]/[0.05] blur-2xl" />
        <span className="relative grid place-items-center size-11 rounded-xl bg-slate-900 text-white shrink-0">
          <Compass className="size-5" strokeWidth={1.6} />
        </span>
        <div className="relative flex-1">
          <h3 className="text-xl sm:text-2xl tracking-[-0.02em] font-medium text-slate-900">
            Your sector not listed? That's not where we stop.
          </h3>
          <p className="mt-2 text-[15px] text-slate-600 leading-relaxed max-w-2xl">
            These ten are where we run deepest — but we design bespoke campaigns for new and niche
            verticals too: compliant sourcing, custom qualifying criteria and dedicated delivery,
            scoped entirely around your market.
          </p>
        </div>
        <div className="relative flex gap-3 flex-wrap shrink-0">
          <Link to="/contact">
            <Button className="rounded-full px-5 h-11 bg-[#0055FF] hover:bg-[#0044CC]" data-testid="sector-cta-discuss-btn">
              Discuss your sector <ArrowUpRight className="size-4" />
            </Button>
          </Link>
          <Link to="/book-demo">
            <Button variant="outline" className="rounded-full px-5 h-11 border-slate-300 hover:border-[#0055FF]/40" data-testid="sector-cta-call-btn">
              Book a call
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
